import type { FreemiumProduct } from '../components/Freemium/interfaces';
import type { RestrictionsProps } from './accessUtils';
import accessUtils from './accessUtils';

// NOTE: make sure possible responses are added to
// upsellType oneOf prop type list in PostActivationModal
const getUpsellType = (
  formData: { [key: string]: unknown },
  canUpdateApplications: boolean,
  userApplicationsEnabled: boolean,
  housingConnectorUpsellEnabled: boolean,
  isHousingConnector: boolean,
) => {
  if (!isHousingConnector && housingConnectorUpsellEnabled) {
    return 'Housing Connector';
  }
  // accepting terms are handled on the back end
  const isApplicationsToggleEnabled = userApplicationsEnabled && formData.isApplicationsAccepted;
  if (canUpdateApplications && !isApplicationsToggleEnabled) {
    return 'Applications';
  }

  if (
    accessUtils.canAccessLeaseBuilder({
      restrictions: formData.restrictions as RestrictionsProps,
    })
  ) {
    return 'Leases';
  }
  return 'None';
};

const getFreemiumProductByType = (freemiumProducts: Array<FreemiumProduct>, productTypeCode: number) => {
  return freemiumProducts.find((p) => p.type === productTypeCode);
};

export { getUpsellType, getFreemiumProductByType };
